module.exports = __webpack_public_path__ + "static/media/59.0ac9f1be.jpg";